import { Component } from '@angular/core';
import { membersuitePaymentEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Payments') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitepayment-form',
    templateUrl: './membersuitepayment.form.component.html'
})
export class membersuitePaymentFormComponent extends BaseFormComponent {
    public record!: membersuitePaymentEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

